// extracted by mini-css-extract-plugin
module.exports = {"title":"OrdersTable_title__hfsml","cnt":"OrdersTable_cnt__tiGc1"};